module.exports = __webpack_public_path__ + "static/img/no10.d5734f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bannerbottom/no10.png
// module id = XiSa
// module chunks = 31